import gsap from 'gsap';

export default () => {
	const anchors = document.querySelectorAll('.js-anchor');
	const duration = 1;
	const ease = 'power3.out';

	anchors.forEach(anchor => {
		anchor.addEventListener('click', (e) => {
			e.preventDefault();

			const href = anchor.getAttribute('href');
			const target = document.querySelector(href);

			if (target) {
				const targetTop = target.getBoundingClientRect().top;
				const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				const headerOffset = document.querySelector('.header').offsetHeight;
				const targetPosition = targetTop + scrollTop - headerOffset;

				let offset = {};
				offset.val = window.scrollY;

				let durationMultiplier = Math.abs(targetPosition) / 3000;

				gsap.to(offset, {
					val: targetPosition,
					duration: duration*durationMultiplier,
					ease: ease,
					onUpdate: () => {
						window.scrollTo(0, offset.val);
					}
				});
			}
		});
	});
}